module.exports = __webpack_public_path__ + "img/instagram.c559141c.svg";